import CheckContent from "components/atoms/CheckContent";
import Img from "components/atoms/Img";
import Title from "components/atoms/Title";

import styles from "./Index.module.scss";

export default function CardMakeDifferent({
  title,
  description,
  src,
  alt,
  rowReverse,
  listWithIcon,
  width,
  height,
}) {
  return (
    <div
      className={`row justify-center ${(rowReverse && "flex-reverse") || ""}`}
    >
      <Img
        loading="lazy"
        src={src}
        width={width || 540}
        height={height || 540}
        className={"h-auto w-full"}
        wrapper={{ className: "lg:col-6 flex items-center justify-center" }}
        alt={alt}
      />
      <div className=" justify-center lg:col-6 lg:flex lg:flex-col">
        <div className="lg:pr-20">
          <Title
            as="h3"
            className=" mt-6 text-lg font-semibold text-bbc-brand-700 lg:mt-0 lg:text-bbc-30px"
          >
            {title}
          </Title>
          <span
            className={`mt-4 inline-block rounded-full lg:mt-6 ${styles.line} `}
          ></span>
          <div className="lg:text-normal mt-4">
            {Array.isArray(description) ? (
              description.map((item, idx) => {
                return (
                  <div key={idx}>
                    <span className="font-semibold">{item.content}</span>
                    {item.listWithIcon ? (
                      <div className="mt-2 mb-6">
                        {item.listWithIcon.map((item, index) => {
                          return <CheckContent key={index} data={item} />;
                        })}
                      </div>
                    ) : (
                      <></>
                    )}
                  </div>
                );
              })
            ) : (
              <>
                {description}
                {listWithIcon ? (
                  <div className="mt-3">
                    {listWithIcon.map((item, index) => {
                      return <CheckContent key={index} data={item} />;
                    })}
                  </div>
                ) : (
                  <></>
                )}
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
